/*
 * @Author: Scarlett Xiao
 * @Date: 2022-02-28 10:59:11
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-10-14 15:48:07
 */
import http from "@/axios/index";
/**
 * @brief: 饲料实时有效库存列表
 * @author: Scarlett Xiao
 * @Date: 2022-03-03 10:22:45
 * @param {*} params
 */
export function searchMdtFodderDataGroupList(params) {
  const url = `/mdtFodderDataGroup/searchMdtFodderDataGroupList`;
  return http.post(url, params)
}
/**
 * @brief: 饲料实时有效库存列表导出
 * @author: Scarlett Xiao
 * @Date: 2022-03-03 10:22:27
 * @param {*} params
 */
export function exportMdtFodderDataGroupList() {
  return `/mdtFodderDataGroup/exportMdtFodderDataGroupList`;
}
/**
 * @brief: 仓库条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-03 10:22:10
 * @param {*} params
 */
export function getGroupConditions(params) {
  const url = `/mdtFodderDataGroup/getGroupConditions`;
  return http.post(url, params)
}
/**
 * @brief: 饲料条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-03 10:21:37
 * @param {*} params
 */
export function getFodderConditions(params) {
  const url = `/mdtFodderDataGroup/getFodderConditions`;
  return http.post(url, params)
}

/////////////////////////////// 饲料投喂记录(与养殖管理平台保持一致) ///////////////////////////////

/**
 * @Author: lgh
 * @Date: 2021-07-16
 * @Descripttion: 获取饲料品类
 * @param {
 * "orgId": "",
 * "type": "fodderCategory"}
 */
export function getListByType(orgId) {
  const url = '/orgType/searchOrgTypeList';
  return http.post(url, {
    orgId: orgId,
    type: 'fodderCategory'
  });
}
/**
 * @Author: hsg
 * @Date: 2021-03-26 14:15:23
 * @Descripttion: 获取基地区域接口
 * @param {string} baseId 基地id
 */
export function queryBaseGroupList(baseId) {
  const url = '/baseGroup/queryBaseGroupList';
  return http.post(url, {
    baseId: baseId,
    groupFlag: '',
  });
}
/**
 * @Author: hsg
 * @Date: 2021-03-26 14:25:45
 * @Descripttion: 获取区域塘口接口
 * @param {string} groupId 区域id
 */
export function listDataPermissionBoxData(groupId) {
  const url = '/boxData/listDataPermissionBoxData/' + groupId;
  return http.get(url);
}
/**
 * 获取列表数据分页
 * @param postObj
 */
export function getListByPages(postObj) {
  const url = '/feedingRecord/getListByPage';
  return http.post(url, postObj);
}
/**
 * 饲料投喂数据导出
 */
export function exportByFodderFeeding() {
  return '/feedingRecord/conditionExportTable';
}
/**
 * @brief: 饲料投喂数据模板下载
 * @author: Scarlett Xiao
 * @Date: 2022-03-08 11:44:36
 */
export function downloadTemplate() {
  // 中文版
  return '/fileDownload/downloadFile/feedingRecordImport_zh';
}
/**
 * @brief: 导入
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 13:49:26
 */
export function fileupload() {
  return '/feedingRecord/importFeedingRecordTable';
}
/**
 * @brief: 根据角色权限获取养殖场下拉列表
 * @author: Scarlett Xiao
 * @Date: 2022-03-03 20:05:18
 */
export function getBaseListsByUser() {
  const url = '/baseData/queryBaseDataListByRole';
  return http.get(url);
}
/**
 * @Author: lishiqiao
 * @Date: 2021-09-06 09:47:34
 * @description: 根据机构id获取饲料列表
 * @param {*} orgId 机构id
 */
export function getFodders(orgId) {
  const url = '/subProf/getFodderList/' + orgId;
  return http.get(url);
}
/**
 * @LastEditors: LinGengHong
 * @LastEditTime: 2021-06-11
 * @description: 获取汇总类型
 * @param {*}
 * @return {*}
 */
export function getTotalType() {
  const url = '/feedingRecord/getGroupByTypeList';
  return http.get(url);
}
/**
 * @brief: 获取echarts数据
 * @author: Scarlett Xiao
 * @Date: 2022-03-07 09:47:15
 * @param {*} postObj
 */
export function getOptionsData(postObj) {
  const url = '/feedingRecord/bar';
  return http.post(url, postObj);
}

//////////////////////////////// 饲料进出存 ////////////////////////////////
/**
 * 获取区域饲料进出存分页
 * @param postObj
 */
export function getPageByFodderArea(postObj) {
  const url = '/fodderInOutSave/getFodderIntoListMap';
  return http.post(url, postObj);
}
/**
 * 区域饲料进出存数据导出
 */
export function exportByFodderArea() {
  return '/fodderInOutSave/getFodderInOutSaveExportTable';
}